(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("selfRegistrationSettings", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/registration/selfRegistrationSettings/selfRegistrationSettingsView.html",
            controller: ["frameworkService", "tenantFeaturesResource", "groupHierarchyResource", "messageService", "$rootScope", "$scope", "$timeout", "_", SelfRegistrationSettingsCtrl],
            controllerAs: "vm"
        };
        function SelfRegistrationSettingsCtrl(frameworkService, tenantFeaturesResource, groupHierarchyResource, messageService, $rootScope, $scope, $timeout, _) {
            var vm = this;
            vm.saving = false;
            vm.loading = true;
            vm.showErrors = false;
            vm.frameworkData = frameworkService.data;
            //vm.organizationEnabled = vm.frameworkData.tenantFeatures.organization;
            //var clearReloadMenu = $rootScope.$on("reloadMenu", () => {
            //	vm.organizationEnabled = frameworkService.data.tenantFeatures.organization;
            //	//vm.organizationRequired = vm.frameworkData.tenant.tenantFeaturesOrganizationIsRequired;
            //});
            //$scope.$on('$destroy', clearReloadMenu);
            tenantFeaturesResource.getSelfRegistrationSettingsViewModel(function (data) {
                vm.model = data;
                groupHierarchyResource.query({ showAllGroups: true }, function (groupData) {
                    vm.groups = groupData;
                    if (vm.model.groupId) {
                        vm.group = _.find(vm.groups, { "id": vm.model.groupId });
                    }
                });
                //delay so switch animation is completed before showing
                $timeout(function () {
                    vm.loading = false;
                }, 200);
            });
            vm.groupChanged = function () {
                if (vm.group)
                    vm.model.groupId = vm.group.id;
                else
                    vm.model.groupId = null;
            };
            vm.onChange = function (newValue) {
                if (!newValue) {
                    $timeout(function () {
                        vm.save();
                    });
                }
            };
            vm.save = function () {
                if (vm.saving)
                    return;
                vm.saving = true;
                //if (vm.model.groupId && (vm.model.organizationId || !vm.organizationRequired || !vm.model.selfRegistrationEnabled)) {
                if (vm.model.groupId) {
                    tenantFeaturesResource.updateSelfRegistrationSettings(vm.model, function () {
                        messageService.success("settings.registration.selfRegister.save.success");
                        $rootScope.$broadcast("reloadTenantSettings");
                        vm.saving = false;
                    }, function (error) {
                        messageService.error(error);
                        vm.saving = false;
                    });
                }
                else {
                    vm.saving = false;
                    vm.showErrors = true;
                }
            };
        }
    });
})();
